export function Error({
  message,
  title,
  icon,
}: {
  message: string;
  title: string;
  icon?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col h-full w-full justify-center items-center bg-[#F7F7F7]">
      <div className="flex flex-col items-center text-center">
        {icon}
        {title && <span className="text-[18px] font-medium mt-4">{title}</span>}
        <div className="text-[14px] mt-2.5 flex flex-col items-center">
          {message.split('\n').map((m) => (
            <span key={m}>{m}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
